import { render, staticRenderFns } from "./HelpCenterLayout.vue?vue&type=template&id=65e3844d&scoped=true&"
import script from "./HelpCenterLayout.vue?vue&type=script&lang=js&"
export * from "./HelpCenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterLayout.vue?vue&type=style&index=0&id=65e3844d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e3844d",
  null
  
)

export default component.exports